import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IApiResponse, IMaxGrupo, Parceiros } from '@/interfaces'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export class GrupoService {
	/**
	 * Retorna a lista com todos os grupos de usuario
	 * @returns Array<IMaxGrupo.IMaxGrupoObject>
	 */
	public static async getGrupos() {
		const response = await http.get<IApiResponse<Array<IMaxGrupo.IMaxGrupoObject>>>(`/grupo`)
		return response.data
	}

	/**
	 * Retorna a lista com todos os grupos de usuario
	 * @returns Array<IMaxGrupo.IMaxGrupoObject>
	 */
	public static async getParceirosVinculo(grupoId: Number) {
		const response = await http.get<IApiResponse<Array<Parceiros.IParceiroTabela>>>(`/grupo/${grupoId}/vinculos-parceiro`)
		return response.data
	}

	/**
	 * Atualiza os vinculos do grupo com parceiros
	 * @returns bool
	 */
	public static async updateGrupoParceiroVinculo(grupoId: Number, parceirosIdList: Array<Number>) {
		const response = await http.post<IApiResponse<Array<Parceiros.IParceiroTabela>>>(`/grupo/${grupoId}/vinculos-parceiro`, {
			grupoId,
			parceirosIdList
		})

		return response.data
	}
}
